import React from 'react'; // Import React
import { Grid, styled } from '@mui/material';
import { COLORS } from '@/theme/colors';
import { T } from '@/theme/tokens';
import DragHandleIcon from '@mui/icons-material/DragHandle';
import { SyntheticListenerMap } from '@dnd-kit/core/dist/hooks/utilities';

export interface AppCardContainerProps {
  noStyles?: boolean;
  children: React.ReactNode;
  draggable?: boolean;
  listeners?: SyntheticListenerMap;
  attributes?: React.HTMLAttributes<any>;
  style?: React.CSSProperties;
  className?: string;
  id?: string;
}

const AppCardContainer = React.forwardRef<
  HTMLDivElement,
  AppCardContainerProps
>(
  (
    {
      noStyles = false,
      draggable = false,
      children,
      listeners,
      attributes,
      style,
      className,
      id,
    },
    ref,
  ) => {
    const Container = noStyles ? UnStyledGridContainer : StyledGridContainer;

    return (
      <Container
        container
        className={`cardsContainer ${className ?? ''}`}
        ref={ref}
        style={style}
        {...attributes}>
        {draggable && (
          <DragHandle {...listeners}>
            <DragHandleIcon />
          </DragHandle>
        )}
        {children}
      </Container>
    );
  },
);

export default AppCardContainer;

export const StyledGridContainer = styled(Grid)(({ theme }) => ({
  display: 'flex',
  backgroundColor: 'transparent',
  borderRadius: T.radius,
  boxShadow: 'none',
  justifyContent: 'space-between',
  columnGap: '1rem',
  margin: 0,
  flexWrap: 'nowrap',
  flexBasis: '100%',
  padding: '1rem',
  justifyItems: 'center',
  position: 'relative',
}));

export const UnStyledGridContainer = styled(Grid)(({ theme }) => ({
  display: 'flex',
  boxShadow: 'none',
  justifyContent: 'space-between',
  columnGap: '1rem',
  flexWrap: 'nowrap',
  flexBasis: '100%',
  padding: 0,
  justifyItems: 'center',
  position: 'relative',
}));

export const DragHandle = styled('div')(({ theme }) => ({
  cursor: 'grab',
  left: 'calc(50% - 20px)',
  top: -12,
  position: 'absolute',
  color: COLORS.primary,
  opacity: 0.5,
  width: 40,
  height: 40,
  zIndex: 10,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  '&:hover': {
    opacity: 1,
  },
}));
